__turbopack_context__.v({
  "button": "DiscoveryProgramList-module__R3qNmG__button",
  "buttons": "DiscoveryProgramList-module__R3qNmG__buttons",
  "eyebrow": "DiscoveryProgramList-module__R3qNmG__eyebrow",
  "footer": "DiscoveryProgramList-module__R3qNmG__footer",
  "footerText": "DiscoveryProgramList-module__R3qNmG__footerText",
  "header": "DiscoveryProgramList-module__R3qNmG__header",
  "section": "DiscoveryProgramList-module__R3qNmG__section",
  "tile": "DiscoveryProgramList-module__R3qNmG__tile",
  "tileArrow": "DiscoveryProgramList-module__R3qNmG__tileArrow",
  "tileBadge": "DiscoveryProgramList-module__R3qNmG__tileBadge",
  "tileBody": "DiscoveryProgramList-module__R3qNmG__tileBody",
  "tileDescription": "DiscoveryProgramList-module__R3qNmG__tileDescription",
  "tileDescriptionRow": "DiscoveryProgramList-module__R3qNmG__tileDescriptionRow",
  "tileDot": "DiscoveryProgramList-module__R3qNmG__tileDot",
  "tileDots": "DiscoveryProgramList-module__R3qNmG__tileDots",
  "tileName": "DiscoveryProgramList-module__R3qNmG__tileName",
  "tileTitleGroup": "DiscoveryProgramList-module__R3qNmG__tileTitleGroup",
  "tiles": "DiscoveryProgramList-module__R3qNmG__tiles",
  "title": "DiscoveryProgramList-module__R3qNmG__title",
});
